import React from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import Avatar from '../../../../../../../../../../../../../../components/avatar/index';
import Icon from '../../../../../../../../../../../../../../components/icon/index';
import Button from '../../../../../../../../../../../../../../components/button';
import DeleteUser from './components/delete-collaborator/index';
import SelectRights from './components/select-rights/index';
import Switch from './components/switch/index';
import UserStatuses from './components/user-statuses/index';
import {permissionCleaner} from "../../../../../../../../../../../../../../utils/index";
import DataListBodyRow from '../../../../../../../../../../../../../../components/data-list/data-list-body/data-list-body-row/index';
import {
	getChangedStatus, hiddenFieldsUpdate,
	selectedCollaborator,
	showHiddenFields, updateCollaborators
} from '../../../../../../../../../../../../../../../actions/sharingDetailsActions';
import './index.css';

class CollaboratorItem extends React.Component{

	constructor(props){
		super(props);
		this.showHiddenFields = this.showHiddenFields.bind(this);
	}

	showHiddenFields () {

		if(this.props.updateCollaborators.length > 0){
			this.props.setUpdateCollaborators([])
		}

		if (this.props.changedStatus){
			this.props.setChangedStatus(false);
		}

		this.props.setSelectedCollaborator({
			"id": this.props.id,
			"index" : this.props.index,
			"name": this.props.name,
			"email": this.props.email,
			"type": this.props.type,
			"statuses": this.props.statuses,
			"permission": this.props.permission,
			"synced": true,
			"hiddenFields": this.props.hiddenFields,
		});

		this.props.setHiddenFieldsUpdate(this.props.hiddenFields);
		this.props.setShowHiddenFields(true);
	}

	render (){

		return (
			<DataListBodyRow
				className={
					`collaborator${
						JSON.stringify(this.props.deletedCollaborators).includes(this.props.id)
						?
							' is-deleting'
						:
							''
					}${this.props.statuses.partiallyShared
                        ?
							' is-partially-shared'
						:
							''
					}`
				}
			>
				<div className="col-4 d-flex align-items-center">
					{
						this.props.type === 'user'
						?
							<Avatar size={'2em'} className="mr-3 border-0" src={this.props.avatar} />
						:
							<Avatar size={'2em'} className="mr-3 border-0" src={'/img/collaborators-group.svg'} />
					}

					<div className="text-truncate mr-2" title={this.props.name}>
						{this.props.name ? <div className="text-nowrap text-truncate"><strong>{this.props.name}</strong></div> : null }
						{this.props.email}
					</div>
				</div>
				<div className="col-3 text-center">
					<UserStatuses
						collaboratorId={this.props.id}
						collaboratorName={this.props.name}
						collaboratorEmail={this.props.email}
						collaboratorType={this.props.type}
						collaboratorPermission={this.props.permission}
						collaboratorStatuses={this.props.statuses}
						selectedCollaboratorMode={this.props.mode === "selectedCollaboratorsGroup"}
						collaboratorHiddenFields={this.props.hiddenFields}
					/>
				</div>
				{
					!this.props.mode &&
					<div className="col-1 text-center">
						{
							(this.props.selectedContactsGroup.id !== '6' || this.props.id !== this.props.profile.id)
							&& ((this.props.selectedContactsGroup.permission === "CAN_SHARE" && this.props.permission !== "OWNER")
								|| this.props.selectedContactsGroup.permission === "OWNER")
								?
								<Switch
									index={this.props.index}
									collaboratorId={this.props.id}
								/>
								:
								null
						}

					</div>
				}
				{
					!this.props.mode &&
					<div className="col-3">
						{
							this.props.isOwner
								?
									<div className="owner-right">
										{permissionCleaner(this.props.permission)}
									</div>
								:
									<SelectRights
										index={this.props.index}
										collaboratorId={this.props.id}
										collaboratorEmail={this.props.email}
										collaboratorType={this.props.type}
										content={this.props.permission}
										internal={this.props.internal}
									/>
	                    }
						{
							!this.props.isOwner && <Button onClick={this.showHiddenFields} className="btn-link hidden-fields">{this.props.t('collaboratorFieldsBtn')}</Button>
						}
					</div>
				}
				{
					!this.props.mode
					?
						<div className="col-1 text-center">
							{
								this.props.isOwner
									?
										<Icon name="lock" />
									:
										<DeleteUser
											index={this.props.index}
											collaboratorId={this.props.id}
										/>
							}
						</div>
					:
						null
				}
			</DataListBodyRow>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
		profile: state.profileReducer.getProfile,
		deletedCollaborators: state.sharingDetailsReducer.getDeletedCollaborators,
		updateCollaborators: state.sharingDetailsReducer.updateCollaborators,
		changedStatus: state.sharingDetailsReducer.getChangedStatus
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setShowHiddenFields : (boolean) => {
			dispatch(showHiddenFields(boolean))
		},
		setSelectedCollaborator : (object) => {
			dispatch(selectedCollaborator(object))
		},
		setUpdateCollaborators : (array) => {
			dispatch(updateCollaborators(array))
		},
		setChangedStatus : (boolean) => {
			dispatch(getChangedStatus(boolean))
		},
		setHiddenFieldsUpdate : (object) => {
			dispatch(hiddenFieldsUpdate(object))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CollaboratorItem));
